var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInvite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "invite_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#invite_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.25 10.5h-2.5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.213.144-.356a.48.48 0 0 1 .356-.143h2.5V7q0-.213.144-.356a.49.49 0 0 1 .357-.144q.212 0 .356.144A.49.49 0 0 1 19.25 7v2.5h2.5q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .213-.144.356a.49.49 0 0 1-.356.143h-2.5V13q0 .213-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144.49.49 0 0 1-.143-.356zM9 11.385a2.9 2.9 0 0 1-2.119-.882A2.9 2.9 0 0 1 6 8.385q0-1.238.881-2.12A2.9 2.9 0 0 1 9 5.386q1.237 0 2.119.88.88.882.881 2.12 0 1.237-.881 2.118A2.9 2.9 0 0 1 9 11.385m-7 6.192v-.608q0-.62.36-1.158.361-.54.97-.838a14.2 14.2 0 0 1 2.833-1.018q1.417-.34 2.837-.34t2.837.34q1.417.34 2.832 1.018.61.298.97.838T16 16.969v.608q0 .44-.299.74-.3.298-.74.298H3.038q-.44 0-.739-.299-.3-.298-.299-.739"
}))));
export default SvgInvite;